import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { createRouter } from '@/routes.tsx';
import { Provider } from '@/components/ui/provider';

import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { msalInstance as msal } from '@/components/auth/authConfig';

import { reactPlugin } from './appInsights';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

if (typeof Temporal === 'undefined') {
  // Polyfill for Temporal.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal
  // As of Jun 2026, implemented in Firefox & Chrome.
  // Safari is implementing.
  // This conditional import will use browser implementation when available.
  await import('temporal-polyfill/global');
}

await msal.initialize();

const ha = msal.getAccount({
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID,
});
if (ha) msal.setActiveAccount(ha);
msal.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const { account } = payload;
    msal.setActiveAccount(account);
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider>
      <AppInsightsContext.Provider value={reactPlugin}>
        <RouterProvider router={createRouter()} />
      </AppInsightsContext.Provider>
    </Provider>
  </StrictMode>,
);
